An array of `JobCategory` identifiers.

This field currently requires a single identifier for a child job category.
